<div class="overflow-hidden rounded-xl border border-slate-200 bg-white">
    <div class="table-responsive">
        <table class="w-full">
            <thead>
                <tr class="border-b border-slate-100 bg-slate-50">
                    <th class="w-12 py-3 ps-4"></th>
                    @if (showYear) {
                        <th
                            class="px-4 py-3 text-start text-xs font-semibold uppercase tracking-wider text-slate-500"
                        >
                            {{ 'translate_year' | translate }}
                        </th>
                    }
                    @if (showPeriod) {
                        <th
                            class="px-4 py-3 text-start text-xs font-semibold uppercase tracking-wider text-slate-500"
                        >
                            {{ 'translate_period' | translate }}
                        </th>
                    }
                    @if (showDepartment) {
                        <th
                            class="px-4 py-3 text-start text-xs font-semibold uppercase tracking-wider text-slate-500"
                        >
                            {{ 'translate_department' | translate }}
                        </th>
                    }
                    @if (!isTrend) {
                        <th
                            class="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-slate-500"
                        >
                            {{ 'translate_target' | translate }}
                        </th>
                    }
                    <th
                        class="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-slate-500"
                    >
                        {{ 'translate_result' | translate }}
                    </th>
                    @if (!isTrend) {
                        <th
                            class="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-slate-500"
                        >
                            {{ 'translate_kpi_achievement' | translate }}
                        </th>
                    }
                    <th
                        class="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-slate-500"
                    >
                        {{ 'translate_details' | translate }}
                    </th>
                    <th class="w-24 px-4 py-3"></th>
                </tr>
            </thead>
            <tbody class="divide-y divide-slate-100">
                @for (row of rows; track trackByFn($index, row)) {
                    <tr
                        class="group transition-colors"
                        [ngClass]="{
                            'bg-primary-50/50': row.isOwningDepartment,
                            'hover:bg-slate-50': !row.isOwningDepartment,
                        }"
                    >
                        <!-- Toggle result details button -->
                        <td class="w-12 ps-4">
                            <button
                                type="button"
                                (click)="toggleResult(row.id)"
                                class="flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 transition-all hover:bg-slate-100 hover:text-slate-600"
                                [ngClass]="{
                                    'bg-primary-50 text-primary-600':
                                        isExpanded(row.id),
                                }"
                            >
                                <i
                                    class="fa-light fa-chevron-down transition-transform"
                                    [ngClass]="{
                                        'rotate-180': isExpanded(row.id),
                                    }"
                                ></i>
                            </button>
                        </td>
                        <!-- Year -->
                        @if (showYear) {
                            <td class="px-4 py-3.5">
                                <span class="font-semibold text-slate-800">{{
                                    row.year
                                }}</span>
                            </td>
                        }
                        <!-- Period -->
                        @if (showPeriod) {
                            <td class="px-4 py-3.5">
                                <span class="text-sm text-slate-600">{{
                                    row.period !== null ? row.period : '—'
                                }}</span>
                            </td>
                        }
                        <!-- Department -->
                        @if (showDepartment) {
                            <td class="px-4 py-3.5">
                                <div class="flex flex-wrap items-center gap-2">
                                    <span class="text-sm text-slate-600">{{
                                        row.department?.name
                                    }}</span>
                                    @if (row.isOwningDepartment) {
                                        <span class="badge badge-warning">
                                            <i class="fa-light fa-crown"></i>
                                            {{
                                                'translate_owning_department'
                                                    | translate
                                            }}
                                        </span>
                                    }
                                </div>
                            </td>
                        }
                        <!-- Target -->
                        @if (!isTrend) {
                            <td class="px-4 py-3.5 text-center">
                                <span class="font-medium text-slate-700">
                                    @if (row.target !== null) {
                                        {{
                                            row.target
                                                | formatKpiResult
                                                    : row.units
                                                    : row.unitsDescription
                                                    : true
                                                    : row.decimalPlaces
                                        }}
                                    } @else {
                                        <span class="text-slate-400">—</span>
                                    }
                                </span>
                            </td>
                        }
                        <!-- Result -->
                        <td class="px-4 py-3.5 text-center">
                            <span class="font-semibold text-slate-800">
                                {{
                                    row.result
                                        | formatKpiResult
                                            : row.units
                                            : row.unitsDescription
                                            : true
                                            : row.decimalPlaces
                                }}
                            </span>
                        </td>
                        <!-- Achieved -->
                        @if (!isTrend) {
                            <td class="text-center">
                                <app-achieved-container
                                    [achieved]="row.achieved"
                                    [decimalPlaces]="row.decimalPlaces"
                                ></app-achieved-container>
                            </td>
                        }
                        <!-- Details column is intentionally left simple; actions stay in feature components -->
                        <td class="px-4 py-3.5 text-center">
                            @if (actionsTemplate) {
                                <ng-container
                                    [ngTemplateOutlet]="actionsTemplate"
                                    [ngTemplateOutletContext]="{ row: row }"
                                ></ng-container>
                            }
                        </td>
                        <td class="px-4 py-3.5 text-center">
                            @if (rowActionsTemplate) {
                                <ng-container
                                    [ngTemplateOutlet]="rowActionsTemplate"
                                    [ngTemplateOutletContext]="{ row: row }"
                                ></ng-container>
                            }
                        </td>
                    </tr>
                    <!-- Expanded details -->
                    @if (isExpanded(row.id)) {
                        <tr class="bg-slate-50/50">
                            <td colspan="9" class="p-0">
                                @if (detailsTemplate) {
                                    <ng-container
                                        [ngTemplateOutlet]="detailsTemplate"
                                        [ngTemplateOutletContext]="{ row: row }"
                                    ></ng-container>
                                }
                            </td>
                        </tr>
                    }
                }
            </tbody>
        </table>
    </div>
</div>
